<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>The Original Watergate Stories</h1>
</div>
</div>
<h4 style="text-align: center;">
	By The Washington Post</h4>
<h5>
	Foreword by Bob Woodward and Carl Bernstein</h5>
<h4 style="text-align: center;">
</h4>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap71683.vue?4c0d5bae